import { ThemeEvents } from '@theme/events';
class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('dialog, .shopify-section');
    this.scope?.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.query = matchMedia('(min-width: 751px)');
    this.query.addEventListener('change', this.updateGridMode);
    customElements.whenDefined('slider-component').then(() => requestAnimationFrame(() => this.updateGridMode()));
  }
  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.query?.removeEventListener('change', this.updateGridMode);
    this.querySelector('slider-component')?.slider?.destroy(true);
  }
  updateGridMode = () => {
    if (!this.isConnected) return;
    const component = this.querySelector('slider-component.product-media-gallery--grid');
    if (!component?.slider) return;
    const grid = this.query.matches && !this.closest('dialog');
    if (grid && !component.dataset.crGridActive) {
      component.slider.destroy(true);
      // Splide retire tabindex et role des diapositives : les déclencheurs de zoom doivent rester accessibles au clavier.
      component.querySelectorAll('[data-zoom-trigger]').forEach((slide) => { slide.tabIndex = 0; slide.setAttribute('role', 'button'); });
      component.dataset.crGridActive = 'true';
      component.resizeObserver?.disconnect();
      component.style.width = '100%'; component.style.marginLeft = '0'; component.style.marginRight = '0';
      this.applyMediaLimit(component);
    } else if (!grid && component.dataset.crGridActive) {
      delete component.dataset.crGridActive;
      this.clearMediaLimit(component);
      component.slider = component.initMainSlider();
      if (component.thumbnailSlider) { component.thumbnailSlider = component.initThumbnailSlider(); component.slider.sync(component.thumbnailSlider); }
      component.slider.mount(); component.thumbnailSlider?.mount();
    }
  };
  // Crunchyroll : seules les N premières photos sont visibles en grille ; « Voir plus » affiche les suivantes.
  applyMediaLimit(component) {
    const limit = Number(component.dataset.crGridLimit || 0);
    const more = this.querySelector('[data-cr-media-more]');
    if (!limit || !more || this.dataset.crMediaExpanded) { if (more) more.hidden = true; return; }
    const slides = [...component.querySelectorAll('.product-media-gallery-main-slider .splide__slide')];
    slides.forEach((slide, index) => slide.classList.toggle('cr-media-hidden', index >= limit));
    more.hidden = slides.length <= limit;
    if (!more.dataset.crBound) {
      more.dataset.crBound = 'true';
      more.addEventListener('click', () => {
        const zoom = this.querySelector('product-zoom');
        if (this.dataset.crMoreAction === 'viewer' && zoom?.open) {
          // Ouvre la visionneuse sur la première photo cachée (les vidéos ne sont pas dans la visionneuse).
          const current = [...this.querySelectorAll('.product-media-gallery-main-slider .splide__slide')];
          const id = current[limit]?.dataset.zoomMediaId;
          const index = id ? [...zoom.querySelectorAll('.product-zoom__slide')].findIndex((slide) => slide.dataset.mediaId === id) : limit;
          zoom.open(more, Math.max(0, index));
          return;
        }
        this.dataset.crMediaExpanded = 'true';
        const first = this.querySelector('.cr-media-hidden');
        this.querySelectorAll('.cr-media-hidden').forEach((slide) => slide.classList.remove('cr-media-hidden'));
        more.hidden = true;
        (first?.querySelector('[tabindex], a, button') || first)?.focus?.({ preventScroll: true });
      });
    }
  }
  clearMediaLimit(component) {
    component.querySelectorAll('.cr-media-hidden').forEach((slide) => slide.classList.remove('cr-media-hidden'));
    const more = this.querySelector('[data-cr-media-more]');
    if (more) more.hidden = true;
  }
  updateMediaGallery = (event) => {
    const source = event.detail?.data?.html?.querySelector('product-media-gallery slider-component');
    const current = this.querySelector('slider-component');
    if (!source || !current) return;
    if (current.innerHTML !== source.innerHTML) {
      current.slider?.destroy(true); current.thumbnailSlider?.destroy(true);
      current.replaceWith(source.cloneNode(true));
      window.ShopifyXR?.setupXRElements();
      requestAnimationFrame(() => this.updateGridMode());
    }
  };
}
if (!customElements.get('product-media-gallery')) customElements.define('product-media-gallery', ProductMediaGallery);
